import { useContext } from 'react'

import { routes } from '@sketch/modules-common'

import { ErrorHandler } from '@sketch/tracing'
import { mapSsoStartUrl } from 'modules/sso/operations/mapSsoStartUrl'

import { ModalContext } from '@sketch/components'
import { default as SignInWithCredentialsModal } from '../modals/SignInWithCredentialsModal'

import { WorkspaceMinimalFragment } from '@sketch/gql-types'

export const useSignInToWorkspace = () => {
  const { showModal } = useContext(ModalContext)

  const signIn = ({
    email,
    name,
    onSuccess,
    avatarSrc,
    workspace,
  }: {
    name: string
    email: string
    onSuccess: () => void
    avatarSrc?: string
    workspace?: WorkspaceMinimalFragment
  }) => {
    const { ssoEnabled, ssoStartUrl } = workspace?.customer || {}
    const isGuestWorkspace = workspace && workspace.userRole === 'GUEST'

    if (workspace && ssoEnabled && !ssoStartUrl) {
      ErrorHandler.shouldNeverHappen(
        `Workspace with id ${workspace.identifier} is configured with SSO but does not have any ssoStartUrl field.`
      )
      return
    }

    if (ssoEnabled && !isGuestWorkspace) {
      window.location.href = mapSsoStartUrl(ssoStartUrl!, {
        from: routes.PERSONAL_SETTINGS_ACCESS_TOKENS_CREATE.create({}),
      })
    } else {
      showModal(SignInWithCredentialsModal, {
        name,
        email,
        onSuccess,
        avatarSrc,
      })
    }
  }

  return { signIn }
}
